<!-- 套餐 菜品详情 -->
<template>
  <div class="home">
    <van-nav-bar
      :style="{ background: sessionStorage.colorCode }"
      :title="$t('PackageDetail.title')"
      left-arrow
      fixed
      :z-index="9"
      @click-left="$router.push('/TakeDishes')"
    >
    </van-nav-bar>
    <div v-if="detail" style="padding-top:46px">
      <div class="dish_content">
        <van-image
          v-if="detail.image"
          width="130px"
          height="130px"
          @click="ImagePreviewBtn(detail.image.path)"
          :src="detail.image.path"
        />
        <van-image
          v-else
          width="130px"
          height="130px"
          :src="sessionStorage.images"
        />
        <div class="info">
          <div
            class="noExceed"
            style="height: 30px;font-size: 16px;line-height: 30px;"
          >
            {{ detail.name }}
          </div>
          <div class="noExceed" style="font-size: 16px;line-height:16px;">
            {{ detail.name_en }}
          </div>
          <div class="dish_footer">
            <van-rate
              style="height: 16px;"
              v-model="detail.level"
              readonly
              :size="16"
              gutter="3px"
              icon="./static/img/Recommend-s.png"
              void-icon="./static/img/Recommend.png"
            />
            <div class="fontLine">
              <span class="currentPrice"
                >{{ sessionStorage.getItem("currency") }}
                {{
                  detail.type == "o"
                    ? detail.original_price
                    : detail.special_price
                }}</span
              >&nbsp;&nbsp;&nbsp;<span
                class="oldPrice"
                v-show="detail.type == 's'"
                >{{ sessionStorage.getItem("currency")
                }}{{ detail.original_price }}</span
              >
            </div>
          </div>
          <p
            style="font-size: 14px;color: #666;padding: 0;margin-bottom: 10px;margin-top: 10px;word-break: break-all;"
          >
            {{ detail.introduction }}
          </p>
        </div>
      </div>
      <div style="height: 3px;width: 100%;background-color: #b7b7b7;"></div>
      <div class="dishList" v-if="detail.tags && detail.tags.data">
        <template v-for="(tag, index) in detail.tags.data">
          <div class="dishItem" v-if="tag.menus.length > 0" :key="index">
            <div
              style="height: 3px;width: 100%;background-color: #F3F5F7;"
            ></div>
            <div class="dishTitle noExceed">
              {{ tag.name }}
            </div>
            <div
              class="dishChild"
              v-for="(menu, key) in tag.menus"
              :key="`menu${key}`"
            >
              <div
                class="dishChild_content"
                :style="
                  typeof checkMenuIndex[index] == 'object'
                    ? checkMenuIndex[index].indexOf(key) != -1
                      ? {
                          border: `2px solid ${sessionStorage.colorCode}`,
                          background: sessionStorage.colorCode,
                          color: '#fff'
                        }
                      : { border: `2px solid ${sessionStorage.colorCode}` }
                    : checkMenuIndex[index] == key
                    ? {
                        border: `2px solid ${sessionStorage.colorCode}`,
                        background: sessionStorage.colorCode,
                        color: '#fff'
                      }
                    : { border: `2px solid ${sessionStorage.colorCode}` }
                "
              >
                <template v-if="tag.is_choiced == 1">
                  <van-image
                    v-if="menu.image"
                    class="noflex"
                    :style="{ border: `2px solid ${sessionStorage.colorCode}` }"
                    width="40"
                    height="40"
                    :src="menu.image.path"
                    @click="changeChildDish(index, menu.target_id, key, 0)"
                  />
                  <van-image
                    v-else
                    class="noflex"
                    :style="{ border: `2px solid ${sessionStorage.colorCode}` }"
                    width="40"
                    height="40"
                    :src="sessionStorage.images"
                    @click="changeChildDish(index, menu.target_id, key, 0)"
                  />
                </template>
                <template v-else>
                  <van-image
                    v-if="menu.image"
                    class="noflex"
                    :class="[
                      checkMenuIndex[index] == key ? 'actChild' : 'childImg'
                    ]"
                    :style="{ border: `2px solid ${sessionStorage.colorCode}` }"
                    width="40"
                    height="40"
                    :src="menu.image.path"
                    @click="changeChildDish(index, menu.target_id, key, 0)"
                  />
                  <van-image
                    v-else
                    class="noflex"
                    :class="[
                      checkMenuIndex[index] == key ? 'actChild' : 'childImg'
                    ]"
                    :style="{ border: `2px solid ${sessionStorage.colorCode}` }"
                    width="40"
                    height="40"
                    src=""
                    @click="changeChildDish(index, menu.target_id, key, 0)"
                  />
                </template>

                <div class="childTitle">
                  <div
                    class="childTitle1 noExceed"
                    @click="changeChildDish(index, menu.target_id, key, 0)"
                  >
                    {{ menu.name }}
                  </div>
                </div>
                <div style="float: right;margin-right:5px">
                  {{ sessionStorage.getItem("currency") }}{{ menu.fill_price }}
                </div>
              </div>
              <template>
                <div class="fr" @click="showTaste(index, key)">
                  <img
                    src="../../static/img/notes.png"
                    :style="{
                      width: '30px',
                      height: '30px',
                      border: `2px solid ${sessionStorage.colorCode}`,
                      borderRadius: '10px',
                      padding: '5px'
                    }"
                  />
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div style="height: 50px;background: #F3F5F7;"></div>
    <van-popup
      v-model="isTasteShow"
      position="bottom"
      :style="{ height: '75%' }"
    >
      <van-cell-group>
        <van-cell>
          <div style="font-size: 16px;" slot="title">
            {{ $t("PackageDetail.note") }}
          </div>
          <van-icon
            slot="right-icon"
            name="./static/img/dele_staff.png"
            size="26px"
            @click="isTasteShow = false"
          />
        </van-cell>
      </van-cell-group>
      <div v-if="actPerfer" class="tasteGropu">
        <template v-for="(item, index) in actPerfer">
          <div
            class="tasteItem"
            v-if="item.category.data.length > 0"
            :key="index"
          >
            <div class="tasteItemTitle">{{ item.name }}</div>
            <span
              class="is_choiced tagsBox"
              v-if="actPerfer[index].is_choiced == 1"
            >
              <div
                v-for="(val, key) in item.category.data"
                :key="key"
                class="tasteItemRadio"
                :style="[
                  childResult[index][key] == val.id
                    ? {
                        background: sessionStorage.colorCode,
                        border: `1px solid ${sessionStorage.colorCode}`,
                        color: '#ffffff'
                      }
                    : { border: `1px solid ${sessionStorage.colorCode}` }
                ]"
                @click="changeResult(val, index, key, val.id)"
              >
                {{ val.name }}
                <span v-if="val.price != 0"
                  >{{ sessionStorage.getItem("currency") }}
                  {{ val.price }}</span
                >
              </div>
            </span>
            <span class="tagsBox" v-else>
              <div
                v-for="(val, key) in item.category.data"
                :key="key"
                class="tasteItemRadio"
                :style="[
                  childResult[index][0] == val.id
                    ? {
                        background: sessionStorage.colorCode,
                        border: `1px solid ${sessionStorage.colorCode}`,
                        color: '#ffffff'
                      }
                    : { border: `1px solid ${sessionStorage.colorCode}` }
                ]"
                @click="changeResult(val, index, key, val.id)"
              >
                {{ val.name }}
                <span v-if="val.price != 0"
                  >{{ sessionStorage.getItem("currency") }}
                  {{ val.price }}</span
                >
              </div>
            </span>
          </div>
        </template>
        <div class="tasteItem">
          <div class="tasteItemTitle">{{ $t("PackageDetail.remark") }}</div>
          <van-field
            v-model="actRemark"
            rows="3"
            autosize
            type="textarea"
            maxlength="80"
            :placeholder="$t('PackageDetail.inputRemark')"
            show-word-limit
            style="text-indent: 10px; border: 1px solid #000; border-radius: 5px;"
          />
        </div>
      </div>
      <div style="width: 100%;height: 50px;">
        <van-button
          :style="{ background: sessionStorage.colorCode }"
          style="width: 90%;height: 35px;margin-left: 5%;margin-top: 7px;line-height: 35px;"
          round
          @click="saveChange()"
          >{{ $t("PackageDetail.certain") }}</van-button
        >
      </div>
    </van-popup>
    <!-- 购物车菜品 -->
    <van-popup
      class="ShopCartBox"
      v-model="isShopCartShow"
      position="bottom"
      :style="{ height: '75%' }"
    >
      <van-cell-group class="cartHeader">
        <van-cell>
          <div
            style="font-size: 18px; font-weight: 600; color: #000"
            slot="title"
          >
            <van-icon
              slot="left-icon"
              name="./static/img/toback.png"
              size="16px"
              @click="isShopCartShow = false"
            />
            <!-- {{ $t("Dishes.cart") }} -->
            {{ $t("Dishes.myCart") }}[ {{ shopCart.count }} ]
          </div>
          <van-icon
            slot="right-icon"
            name="./static/img/empty.png"
            size="26px"
            @click="chearShopcart"
          />
        </van-cell>
      </van-cell-group>
      <div class="cartDetail" v-if="shopCart.data">
        <template v-for="(dish, index) in shopCart.data">
          <div class="cartItem" :key="index">
            <!-- 产品 -->
            <div class="cart_dish">
              <div class="dish noExceed">
                <template v-if="dish.image">
                  <van-image
                    class="menuImg"
                    width="70"
                    height="70"
                    :src="dish.image.path"
                  />
                </template>
                <template v-else>
                  <van-image
                    class="menuImg"
                    width="70"
                    height="70"
                    :src="sessionStorage.images"
                  />
                </template>
                <div style="margin-left: 10px; width: calc(100% - 80px);">
                  <div class="menu_name">{{ dish.menu_name }}</div>
                  <div class="cart_dish_des noExceed">
                    <template
                      v-if="dish.menus_name.length == 0 && dish.tags_name"
                    >
                      <span
                        v-for="(tagName, index) in dish.tags_name"
                        :key="index"
                      >
                        {{ tagName }}，
                      </span>
                    </template>
                    <span
                      v-if="dish.menus_name.length == 0 && dish.remark[0] != ''"
                      >{{ $t("PackageDetail.remark") }}：</span
                    >
                    <template
                      v-if="dish.menus_name.length == 0 && dish.remark[0] != ''"
                    >
                      ({{ dish.remark[0] }})
                    </template>
                  </div>
                  <div
                    style="display: flex; align-items: center; justify-content: space-between;"
                  >
                    <div class="realPrice">
                      {{ sessionStorage.getItem("currency") }}{{ dish.price }}
                    </div>
                    <!-- 加减和价格 -->
                    <div class="icon_group">
                      <div class="cart_dish_icon fl">
                        <van-icon
                          class="reduceBtn"
                          :style="{
                            border: `1px solid ${sessionStorage.colorCode}`
                          }"
                          name="./static/img/reduce.png"
                          size="10px"
                          @click="subShopCart(dish.id, dish.number)"
                        ></van-icon>
                        <span
                          style="
                              display: inline-block;
                              min-width: 30px;
                              height: 30px;
                              text-align: center;
                              line-height: 30px;
                              vertical-align: top;
                            "
                        >
                          {{ dish.number }}
                        </span>
                        <van-icon
                          class="addBtn"
                          :style="{ background: sessionStorage.colorCode }"
                          name="./static/img/add.png"
                          size="12px"
                          @click="addShopCart(dish.id)"
                        ></van-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 套餐 -->
              <div v-if="dish.menus_name">
                <div
                  class="cart_dish son_dish"
                  v-for="(menu, key) in dish.menus_name"
                  :key="key"
                >
                  <div
                    v-if="typeof menu == 'object'"
                    class="cart_dish_name noExceed fl"
                  >
                    <template v-for="(menuArr, i) in menu">
                      {{ menuArr }}{{ i == menu.length - 1 ? "" : "、" }}
                    </template>
                  </div>
                  <div v-else class="cart_dish_name noExceed fl">
                    {{ menu }}
                  </div>

                  <div
                    v-if="typeof menu == 'object'"
                    class="cart_dish_price noExceed fl"
                  >
                    {{ sessionStorage.getItem("currency") }}
                    <template v-for="(priceArr, j) in dish.fill_price[key]">
                      {{ j == 0 ? priceTotal(dish.fill_price[key]) : "" }}
                    </template>
                  </div>
                  <div v-else class="cart_dish_price noExceed fl">
                    {{ sessionStorage.getItem("currency")
                    }}{{ dish.fill_price[key] }}
                  </div>
                  <div class="cart_dish_des noExceed fl">
                    <template v-if="dish.tags_name[key]">
                      <template v-if="typeof dish.tags_name[key] == 'object'">
                        <template v-for="(tagName, i) in dish.tags_name[key]">
                          <template v-if="typeof tagName == 'object'">
                            {{ arrShow(tagName) }}
                          </template>
                          <template v-else>
                            {{ tagName }}
                          </template>
                          <template v-if="dish.remark[key][i]">
                            ({{ dish.remark[key][i]
                            }}{{
                              i == dish.remark[key].length - 1 ||
                              !dish.remark[key][i]
                                ? ""
                                : ""
                            }})
                          </template>
                          &nbsp;&nbsp;
                        </template>
                      </template>
                      <template v-else>
                        {{ dish.tags_name[key] }}
                        <template v-if="dish.remark[key]">
                          ({{ dish.remark[key] }})
                        </template>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
              <!-- <div v-if="dish.menus_name" class="cart_dish_price noExceed fl">
                  {{ sessionStorage.getItem("currency") }}
                  {{ dish.original_price / dish.number }}
                </div> -->
            </div>
          </div>
          <van-divider style="margin: 10px 0;" />
        </template>
        <div style="height: 50px;"></div>
      </div>
      <!-- <van-tabbar class="flexNone" style="background: #000;">
          <div style="width: 88%; height: 34px; margin: 8px 6%;">
            <div class="cart_left">
              <div class="fl total_price" style="text-indent: 0;">
                {{ sessionStorage.getItem("currency") }}{{ shopCart.total }}
              </div>
            </div>
            <div class="cart_right">
              <van-button
                color="#2f75f4"
                class="cart_right_btn"
                round
                @click="cook()"
              >
                {{ $t("Dishes.order") }}
              </van-button>
            </div>
          </div>
        </van-tabbar> -->
      <van-tabbar
        :fixed="true"
        style="background: #fff; box-shadow: 0px 0px 10px #979797; padding: 0px 0px 10px;"
      >
        <div
          style="width: 88%; height: 45px; padding: 10px 0px 0px; margin: 8px auto; overflow: hidden;"
        >
          <div class="cart_left" @click="isShopCartShow = true">
            <van-badge :content="shopCart.count">
              <svg-icon
                :style="{
                  width: '34px',
                  height: '34px',
                  filter: `drop-shadow(${sessionStorage.colorCode} 100px 0)`,
                  transform: 'translateX(-100px)'
                }"
                iconClass="cart"
                class="icon"
              />
            </van-badge>
          </div>
          <div class="cart_right">
            <div
              class="fl total_price"
              :style="{ color: sessionStorage.colorCode }"
            >
              {{ sessionStorage.getItem("currency") }}{{ shopCart.total }}
            </div>
            <!-- 下单按钮 -->
            <van-button
              :color="sessionStorage.colorCode"
              class="cart_right_btn"
              round
              @click="cook()"
            >
              OK
            </van-button>
          </div>
        </div>
      </van-tabbar>
    </van-popup>
    <!-- 底部固定购物车栏 -->
    <van-tabbar
      :fixed="true"
      style="background: #fff; box-shadow: 0px 0px 10px #979797; padding: 0px 0px 10px;"
    >
      <div
        style="width: 88%; height: 45px; padding: 10px 0px 0px; margin: 8px auto; overflow: hidden;"
      >
        <div class="cart_left" @click="isShopCartShow = true">
          <!-- <van-icon
              class="fl"
              name="../assets/icons/svg/cart.svg"
              :badge="shopCart.count"
              @click="isShopCartShow = true"
              size="34px"
            /> -->
          <van-badge :content="shopCart.count">
            <svg-icon
              :style="{
                width: '34px',
                height: '34px',
                filter: `drop-shadow(${sessionStorage.colorCode} 100px 0)`,
                transform: 'translateX(-100px)'
              }"
              iconClass="cart"
              class="icon"
            />
          </van-badge>
        </div>
        <div class="cart_right">
          <div
            class="fl total_price"
            :style="{ color: sessionStorage.colorCode }"
          >
            {{ sessionStorage.getItem("currency") }}{{ shopCart.total }}
          </div>
          <!-- 下单按钮 -->
          <van-button
            :color="sessionStorage.colorCode"
            class="cart_right_btn"
            round
            @click="addCart()"
          >
            <!-- {{ $t("Dishes.order") }} -->
            <van-image
              style="margin-top: 10px"
              width="30"
              height="25"
              src="./static/img/addCart.png"
            />
          </van-button>
        </div>
      </div>
    </van-tabbar>
    <div
      class="inDot"
      :style="{ bottom: bottomNum + 'px', left: leftNum + 'px' }"
      v-show="visible"
    ></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: {},
      isTasteShow: false,
      isChoiced: 0,
      actPerfer: [],
      actRemark: "",
      menus_id: [],
      checkMenuIndex: [],
      tags_id: [],
      fill_price: [],
      remarks: [],
      perferResult: [],
      childResult: [],
      actIndex: "",
      actIndexKey: "",
      isShopCartShow: false,
      shopCart: {}, //购物车数据
      //动效 声音
      visible: false,
      bottomNum: 33,
      leftNum: 50,
      musicPlayer: new Audio()
    };
  },
  created() {
    this.getPackageDetail();
    this.getShopCart();
    this.musicPlayer.src = "./static/music/add_dish.mp3";
    this.musicPlayer.loop = false;
    this.musicPlayer.preload = "auto";
  },
  computed: {
    isSelectImg() {
      return function(index, key) {
        return this.checkMenuIndex[index].indexOf(key) != -1
          ? "actChild"
          : "childImg";
      };
    },
    priceTotal() {
      return function(arr) {
        var sum = 0;
        for (var i in arr) {
          sum += Number(arr[i]);
        }
        console.log(sum);
        return sum;
      };
    },
    arrShow() {
      return function(arr) {
        var str = "";
        for (var i in arr) {
          str +=
            arr[i] +
            (i == arr.length - 1 || !arr[i]
              ? ""
              : arr[i].indexOf("(") == -1
              ? "，"
              : "");
        }
        return str;
      };
    }
  },
  methods: {
    // 图片预览
    ImagePreviewBtn(imgUrl) {
      if (imgUrl) {
        this.ImagePreview([`${imgUrl}`]);
      }
    },
    // 获取套餐菜品详情
    getPackageDetail() {
      this.$axios({
        method: "get",
        url: this.$build + "/api/menu/" + this.$route.params.id + "/takeIndex"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.detail = res.data.data;

            let menuArr = []; //移除那些没有menus的数据
            let tagsDataArr = res.data.data.tags.data;
            for (var i = 0; i < tagsDataArr.length; i++) {
              var temp = {};
              temp.key = i;
              temp.id = "";
              var remarkArr = [];
              var perfer = [];
              var price = 0;
              if (tagsDataArr[i].is_choiced == 1) {
                if (tagsDataArr[i].menus.length > 0) {
                  menuArr.push(tagsDataArr[i]);
                  this.checkMenuIndex.push([0]);
                  temp.id = [tagsDataArr[i].menus[0].target_id];
                  price = [tagsDataArr[i].menus[0].fill_price];
                  for (let k = 0; k < tagsDataArr[i].menus.length; k++) {
                    let perferChild = [];
                    if (tagsDataArr[i].menus[k].perfer.length > 0) {
                      for (
                        let j = 0;
                        j < tagsDataArr[i].menus[k].perfer.length;
                        j++
                      ) {
                        if (
                          tagsDataArr[i].menus[k].perfer[j].category.data
                            .length > 0
                        ) {
                          perferChild.push(
                            tagsDataArr[i].menus[k].perfer[j].category.data[0]
                              .id
                          );
                        }
                      }
                    } else {
                      perferChild.push("");
                    }
                    perfer.push(perferChild);
                    remarkArr.push("");
                  }
                  this.fill_price.push(price);
                }
              } else {
                if (tagsDataArr[i].menus.length > 0) {
                  menuArr.push(tagsDataArr[i]);
                  this.checkMenuIndex.push(0);
                  console.log(this.checkMenuIndex, "查看数据666");
                  temp.id = tagsDataArr[i].menus[0].target_id;
                  price = tagsDataArr[i].menus[0].fill_price;
                  for (
                    var j = 0;
                    j < tagsDataArr[i].menus[0].perfer.length;
                    j++
                  ) {
                    if (
                      tagsDataArr[i].menus[0].perfer[j].category.data.length > 0
                    ) {
                      perfer.push(
                        tagsDataArr[i].menus[0].perfer[j].category.data[0].id
                      );
                    }
                  }
                  this.fill_price.push(price);
                }
              }
              if (tagsDataArr[i].menus.length > 0) {
                if (tagsDataArr[i].is_choiced == 1) {
                  this.perferResult.push(perfer);
                  this.remarks.push(remarkArr);
                } else {
                  this.perferResult.push(perfer);
                  this.remarks.push("");
                }
                this.menus_id.push(temp);
              }
            }
            this.detail.tags.data = menuArr;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    //获取购物车详情
    getShopCart() {
      this.$axios({
        method: "post",
        url: this.$build + "/api/place/takeShopcart",
        data: {
          code: localStorage.getItem("onlyCode")
        }
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            this.shopCart = res.data;
            this.shopCart.data.forEach(item => {
              let arr = [];
              if (item.menus_name.length != 0 && item.tags_name) {
                // 套餐偏好重新排版
                item.tags_name.forEach((i, num) => {
                  i.forEach((j, index) => {
                    let list = []; //临时存储
                    if (i.length > 1) {
                      list.push(`(${item.menus_name[num][index]})：`);
                    }
                    if (typeof j == "object") {
                      j.forEach(tag => {
                        list.push(tag);
                      });
                    } else {
                      list.push(j);
                    }
                    i.splice(index, 1, list);
                  });
                });
              } else if (item.menus_name.length == 0 && item.tags_name) {
                // 单品偏好重新排版
                if (item.tags_name[0] != "") {
                  item.tags_name.forEach(i => {
                    i.forEach(j => {
                      if (typeof j == "object") {
                        j.forEach(tag => {
                          arr.push(tag);
                        });
                      } else {
                        arr.push(j);
                      }
                    });
                  });
                }
                item.tags_name = arr;
              }
            });
          } else {
            // 购物车为空弹窗
            // for (var item in res.data.error) {
            //     this.$toast({
            //         duration:1000,
            //         type:'fail',
            //         message:res.data.error[item],
            //     });
            // }
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 增加商品
    addShopCart(id) {
      this.$axios({
        method: "PATCH",
        url: this.$build + "/api/shopcart/" + id + "/takeUpdate",
        data: {
          type: "add"
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.getShopCart();
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 减少商品
    subShopCart(id, number) {
      if (number == 1) {
        this.$dialog
          .confirm({
            title: this.$t("Dishes.del"),
            message: this.$t("Dishes.isDel"),
            confirmButtonColor: "#FFC813",
            confirmButtonText: this.$t("vantText.confirm"),
            cancelButtonText: this.$t("vantText.cancel")
          })
          .then(() => {
            this.$axios({
              method: "PATCH",
              url: this.$build + "/api/shopcart/" + id + "/takeUpdate",
              data: {
                type: "reduce"
              }
            })
              .then(res => {
                // console.log(res);
                if (res.data.status == 200) {
                  this.getShopCart();
                } else {
                  this.$toast.allowMultiple();
                  for (var item in res.data.error) {
                    this.$toast({
                      duration: 1000,
                      type: "fail",
                      message: res.data.error[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  duration: 1000,
                  type: "fail",
                  message: this.$t("common.message")
                });
              });
          })
          .catch(() => {});
      } else {
        this.$axios({
          method: "PATCH",
          url: this.$build + "/api/shopcart/" + id + "/takeUpdate",
          data: {
            type: "reduce"
          }
        })
          .then(res => {
            // console.log(res);
            if (res.data.status == 200) {
              this.getShopCart();
            } else {
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  duration: 1000,
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              duration: 1000,
              type: "fail",
              message: this.$t("common.message")
            });
          });
      }
    },
    // 加入购物车
    addCart() {
      var tmenuids = [];
      var tremarks = [];
      var tperferResult = [];
      for (var i = 0; i < this.menus_id.length; i++) {
        let tperferResultArr = [],
          remarkArr = [];
        if (this.menus_id[i].id) {
          if (
            this.checkMenuIndex[i] == 0 ||
            typeof this.checkMenuIndex[i] == "number"
          ) {
            tperferResultArr = this.perferResult[i];
            remarkArr = this.remarks[i];
          } else {
            for (var key in this.checkMenuIndex[i]) {
              tperferResultArr.push(
                this.perferResult[i][this.checkMenuIndex[i][key]]
              );
              let remark = this.remarks[i]
                ? this.remarks[i][this.checkMenuIndex[i][key]]
                  ? this.remarks[i][this.checkMenuIndex[i][key]]
                  : ""
                : "";
              remarkArr.push(remark);
            }
          }
          tmenuids.push(this.menus_id[i].id);
          tremarks.push(remarkArr);
          tperferResult.push(tperferResultArr);
        }
      }
      var perferIds = [];
      perferIds.push(this.perferResult);
      // 删除偏好空值
      let perferList = JSON.parse(JSON.stringify(tperferResult));
      perferList.forEach(arr => {
        arr.forEach(code => {
          console.log(code);
          if (typeof code == "object") {
            code.forEach((item, index) => {
              if (item.length == 1) {
                code.splice(index, 1, item[0]);
              } else if (item.length > 1) {
                item.forEach((j, num) => {
                  if (j == "" || j == null) {
                    item.splice(num, 1);
                  }
                });
              }
            });
          }
        });
      });
      // 当菜品只有一个多选时进行数据机构处理；判断菜品是否存在，进行删除多余偏好
      perferList.forEach((item, num) => {
        item.forEach((arr, index) => {
          if (arr.length == 1 && typeof arr[0] == "object") {
            item.splice(index, 1, arr[0]);
          }
          if (typeof this.checkMenuIndex[num][index] == "undefined") {
            item.splice(index, 1);
          }
        });
      });
      var data = {
        menus_id: JSON.stringify(tmenuids),
        tags_id: JSON.stringify(perferList),
        remark: JSON.stringify(tremarks),
        fill_price: JSON.stringify(this.fill_price)
      };
      // console.log(data);
      this.$axios({
        method: "post",
        url: this.$build + "/api/shopcart/takeStore",
        data: {
          code: localStorage.onlyCode,
          menu_id: this.$route.params.id,
          menus_id: JSON.stringify(tmenuids),
          tags_id: JSON.stringify(perferList),
          remark: JSON.stringify(tremarks),
          fill_price: JSON.stringify(this.fill_price)
        }
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });
            this.addAnimation();
            this.musicPlayer.currentTime = 0;
            this.musicPlayer.play();
            this.getShopCart();
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 弹出偏好设置，并设置该偏好的数据
    showTaste(index, key) {
      // this.actIndex=index;
      // this.actPerfer=this.detail.tags.data[index].menus[key].perfer;
      // this.actRemark=this.remarks[index];
      // this.childResult=this.perferResult[index];
      // this.isTasteShow=true;
      if (this.detail.tags.data[index].is_choiced == 1) {
        this.actPerfer = this.detail.tags.data[index].menus[key].perfer;
        this.actRemark = this.remarks[index][key]
          ? this.remarks[index][key]
          : "";
        this.actIndex = index;
        this.actIndexKey = key;
        this.isChoiced = 1;
      } else {
        this.actPerfer = this.detail.tags.data[index].menus[key].perfer;
        this.actRemark = this.remarks[index] ? this.remarks[index] : "";
        this.actIndex = index;
        this.actIndexKey = key;
        this.isChoiced = 0;
      }
      this.childResult = [];
      for (var i = 0; i < this.actPerfer.length; i++) {
        if (this.actPerfer[i].category.data.length > 0) {
          this.childResult[i] = [];
          let data = this.actPerfer[i].category.data;
          for (let index = 0; index < data.length; index++) {
            const item = data[index];
            if (item.is_choiced == 1) {
              this.childResult[i].push(item.id);
            } else if (this.actPerfer[i].is_choiced == 1) {
              if (item.is_choiced == 1) {
                this.childResult[i].splice(index, 1, item.id);
              } else {
                this.childResult[i].splice(index, 1, "");
              }
              console.log(index, this.childResult[i]);
            }
          }
          let list = this.childResult[i].filter(item => {
            return item != "";
          });
          if (list.length == 0) {
            this.childResult[i] = [];
          }
          if (this.childResult[i].length == 0) {
            this.childResult[i].push(this.actPerfer[i].category.data[0].id);
            this.actPerfer[i].category.data[0].is_choiced = 1;
          }
        }
      }
      this.isTasteShow = true;
    },
    // 判断数组的值是否全为空
    areAllValuesEmpty(array) {
      return array.every(
        value =>
          value === null ||
          value === undefined ||
          value === "" ||
          value === 0 ||
          value === false
      );
    },
    // 选择偏好标签
    changeResult(value, index, key, id) {
      if (this.actPerfer[index].is_choiced == 1) {
        let arr = JSON.parse(JSON.stringify(this.childResult[index]));
        let type = arr.indexOf(id);
        type == -1 ? (arr[key] = id) : arr.splice(type, 1, "");
        if (!this.areAllValuesEmpty(arr)) {
          this.$set(this.childResult, index, arr);
        }
        value.is_choiced = value.is_choiced == 1 ? 0 : 1;
      } else {
        this.actPerfer[index].category.data.forEach(item => {
          item.is_choiced = 0;
        });
        value.is_choiced = value.is_choiced == 1 ? 0 : 1;
        let arr = this.childResult[index];
        arr[0] = arr[0] == id ? "" : id;
        this.$set(this.childResult, index, arr);
      }
    },
    // 保存修改
    saveChange() {
      if (this.isChoiced == 1) {
        this.$set(
          this.remarks[this.actIndex],
          this.actIndexKey,
          this.actRemark
        );
        this.$set(
          this.perferResult[this.actIndex],
          this.actIndexKey,
          this.childResult
        );
        this.changeChildDish(
          this.actIndex,
          this.detail.tags.data[this.actIndex].menus[this.actIndexKey]
            .target_id,
          this.actIndexKey,
          1
        );
      } else {
        this.$set(this.remarks, this.actIndex, this.actRemark);
        this.$set(this.perferResult, this.actIndex, this.childResult);
      }
      this.isTasteShow = false;
      this.actRemark = "";
    },
    // 点击修改选择单品
    changeChildDish(index, id, key, type) {
      // console.log("***********************************");
      this.actPerfer = this.detail.tags.data[index].menus[key].perfer;
      this.actIndex = index;

      if (this.detail.tags.data[index].is_choiced == 0) {
        this.menus_id[index].id = id;
        this.$set(this.checkMenuIndex, index, key);
        this.fill_price[index] = this.detail.tags.data[index].menus[
          key
        ].fill_price;
        if (type == 0) {
          let perferId = [];
          for (let i in this.actPerfer) {
            perferId.push(this.actPerfer[i].category.data[0].id);
          }
          this.childResult = perferId ? perferId : [];
          this.$set(this.perferResult, this.actIndex, this.childResult);
        }
      } else {
        // 点击修改选择单品
        var arr = [];
        if (typeof this.checkMenuIndex[index] == "number") {
          arr.push(this.checkMenuIndex[index]);
          var i = arr.indexOf(key);
          if (i == -1) {
            arr.push(key);
          } else {
            if (arr.length > 1) {
              arr.splice(i, 1);
            }
          }
        } else {
          arr = this.checkMenuIndex[index];
          if (type == 1) {
            var i = arr.indexOf(key);
            if (i == -1) {
              arr.push(key);
            }
          } else {
            var i = arr.indexOf(key);
            if (i == -1) {
              arr.push(key);
            } else {
              if (arr.length > 1) {
                arr.splice(i, 1);
              }
            }
          }
        }
        function compare(val1, val2) {
          return val1 - val2;
        }
        arr.sort(compare);
        // console.log(arr);

        this.$set(this.checkMenuIndex, index, arr);
        var arrId = [],
          priceId = [];
        for (var j in arr) {
          arrId.push(this.detail.tags.data[index].menus[arr[j]].target_id);
          priceId.push(this.detail.tags.data[index].menus[arr[j]].fill_price);
        }
        this.menus_id[index].id = arrId;
        this.fill_price[index] = priceId;
        let perferId = [];
        for (let i in this.actPerfer) {
          perferId.push(this.actPerfer[i].category.data[0].id);
        }
        this.childResult = perferId ? perferId : [];
      }
      // console.log(this.fill_price);
      console.log(this.checkMenuIndex);
    },
    // 动效
    addAnimation() {
      this.visible = true;
      this.bottomNum = 33;
      this.leftNum = 250;
      var that = this;
      var timer = setInterval(function() {
        if (that.leftNum > 150 && that.bottomNum < 133) {
          that.bottomNum += 5;
        } else if (that.leftNum <= 150 && that.bottomNum > 33) {
          that.bottomNum -= 5;
        } else {
          that.bottomNum = 33;
          that.visible = false;
          clearInterval(timer);
        }
        if (that.leftNum > 50) {
          that.leftNum -= 5;
        } else {
          that.leftNum = 50;
        }
      }, 10);
    },
    cook() {
      // this.$router.push('/Address');
      this.$router.push("/TakeCartDetail");
    },
    backBtn() {
      this.isShopCartShow = false;
      this.$router.go(-1);
    },
    // 清空购物车
    chearShopcart() {
      this.$axios({
        method: "DELETE",
        url: this.$build + "/api/shopcart/takeClear",
        data: {
          code: localStorage.getItem("onlyCode")
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.getShopCart();
            this.getDishes();
            this.$toast({
              type: "success",
              message: res.data.message,
              duration: 1000
            });
          } else {
            this.$toast.allowMultiple();
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-field__body > input {
  text-align: right;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #2f75f4;
}
/deep/ .van-divider {
  border-width: 2px;
}
/deep/ .van-info {
  border-color: #000;
}
/deep/ .dish_content .van-image {
  padding: 5px 10px 10px;
}
/deep/ .van-image img {
  border-radius: 6px;
  max-width: 25rem;
  margin: 0 auto;
}
/deep/ .ShopCartBox .van-popup .van-cell {
  position: fixed;
  z-index: 999;
}
.noflex {
  border-radius: 8px;
  position: relative;
  left: -1px;
}
.dish_content {
  display: flex;
}
.dish_footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
}
.home {
  width: 100%;
  height: auto;
  background-color: #fff;
}
.currentPrice {
  font-size: 20px;
  font-weight: 600;
  color: #fe2a00;
  /* color: #ff6666; */
}
.oldPrice {
  color: #bcbcbc;
  text-decoration: line-through;
}
.info {
  /* width: 90%;
  margin-left: 5%; */
  width: calc(90% - 110px);
  height: auto;
  position: relative;
}
.fontLine {
  padding-bottom: 10px;
  font-size: 14px;
}
.setPerfer {
  position: absolute;
  width: 35px;
  height: 35px;
  bottom: 10px;
  right: 0px;
}
.flexNone {
  flex: none;
}
.cart_left {
  width: 70%;
  height: 34px;
  line-height: 34px;
  float: left;
}
.cart_right {
  width: 30%;
  height: 34px;
  line-height: 26px;
  float: right;
  text-align: right;
  display: flex;
  justify-content: right;
}
.cart_right_btn {
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  color: #222;
  padding: 5px 35px;
  font-weight: 600;
  font-size: 18px;
}
.total_price {
  height: 34px;
  line-height: 34px;
  text-indent: 10px;
  font-size: 20px;
  font-weight: 600;
  text-align: right;
  margin-right: 10px;
}
.tasteGropu {
  width: 90%;
  margin-left: 5%;
  font-size: 16px;
  height: auto;
}
.tasteItem {
  width: 100%;
  height: auto;
  color: #000;
}
.tasteItemTitle {
  width: 100%;
  height: 45px;
  line-height: 45px;
}
.tasteItemRadio {
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 5px;
  margin-left: 10px;
  margin-bottom: 10px;
  color: #000;
}
.tasteItemRadio_act {
  background-color: #2f75f4;
  color: #fff;
}
.dishList {
  width: 100%;
  min-height: 5rem;
  max-height: 80vh;
  overflow-y: auto;
  font-size: 14px;
  margin-bottom: 50px;
}
.dishItem {
  width: 90%;
  margin-left: 5%;
  min-height: 80px;
}
.dishItem:last-child {
  padding-bottom: 7.5rem;
}
.dishTitle {
  width: 100%;
  height: 36px;
  line-height: 36px;
}
.dishChild {
  width: 100%;
  padding-bottom: 0.625rem;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  z-index: 1;
}
.childTitle {
  flex: auto;
  height: 42px;
  text-indent: 10px;
  width: 100px;
  display: flex;
  align-items: center;
}
.childTitle1 {
  width: 100%;
  height: 20px;
  line-height: 20px;
}
.selChild {
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 2;
}
.actChild {
  border: 0.125rem solid #2f75f4;
  border-radius: 10px;
}
.childImg {
  border: 0.125rem solid #ddd;
  border-radius: 10px;
  overflow: hidden;
}
.van-button__text {
  color: #fff;
}
.icontext {
  position: absolute;
  font-size: 14px;
  right: 0px;
}
.cartHeader {
  width: 100%;
  position: fixed;
  background: #fff;
  z-index: 10;
}
.cartDetail {
  width: 100%;
  height: auto;
  margin-top: 50px;
}
.cartItem {
  width: 90%;
  margin-left: 5%;
  position: relative;
}
.cart_dish {
  width: 100%;
  overflow: hidden;
}
.cart_dish_name {
  width: 80%;
  height: 60px;
  line-height: 60px;
  text-indent: 5px;
}
.cart_dish_icon {
  width: 80%;
  height: 40px;
  line-height: 40px;
}
.cart_dish_price {
  width: 20%;
  height: 35px;
  line-height: 35px;
  text-align: right;
  color: #aaa;
}
.cart_dish_des {
  width: calc(100% - 60px);
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  color: #ccc;
}
.dish {
  display: flex;
}
.son_dish > .cart_dish_name {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_price {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_des {
  height: 18px;
  line-height: 18px;
  font-size: 12px;
}
.icon_group {
  height: 35px;
  line-height: 35px;
}
.realPrice {
  color: #fb2525;
  font-weight: 600;
}
.inDot {
  width: 24px;
  height: 24px;
  background: #ee0a24;
  border-radius: 50%;
  position: fixed;
  z-index: 2;
}
.tasteBtn {
  width: 50px;
  height: 32px;
  /* background:url('/static/img/Option.png'); */
  background-size: contain;
}
.mright {
  position: absolute;
  right: 0.625rem;
}
.mleft {
  position: absolute;
  right: 6.25rem;
}
@media screen and (min-width: 480px) {
  .mright {
    position: absolute;
    right: 2.5rem;
  }
  .mleft {
    position: absolute;
    right: 8.75rem;
  }
}
.reduceBtn,
.addBtn {
  border-radius: 8px;
  padding: 5px;
}
.tagsBox {
  display: flex;
  flex-wrap: wrap;
}
.dishChild_content {
  display: flex;
  align-items: center;
  width: 100%;
  margin-right: 10px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/takeAway/TakePackageDetail.vue